var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 45.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#425eab;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.35,20.05l-10-17.52A4.92,4.92,0,0,0,35,0H15a4.91,4.91,0,0,0-4.32,2.53L6.86,9.21l-2,3.48L.65,20.05A5,5,0,0,0,.65,25l4.2,7.36,2,3.48,3.83,6.68A4.9,4.9,0,0,0,15,45H35a4.91,4.91,0,0,0,4.33-2.52L49.35,25A5,5,0,0,0,50,22.52a4.85,4.85,0,0,0-.65-2.47M38.38,35h0v0Zm7.37-12.47L38.4,35c-.29,0-.58.06-.89.06A12.49,12.49,0,0,1,25,22.77v-.3A12.52,12.52,0,0,0,12.51,10a6.48,6.48,0,0,0-.77.08l3-5.08H35.41L45.77,22.52Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset 6.ae6f5be8f7eac80414001da4b6786e25.svg";
export { ForwardRef as ReactComponent };